import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useInView } from 'react-intersection-observer';

import { h1 } from '~/styles/typography';

import { transition } from '~/styles/transition';
import { dynamicFontSize, formatText } from '~/utilities/helpers';

const Text = styled.h2`
    ${transition({ speed: 800, easingFunction: 'ease-in-out' }, 'color')};
    ${h1}
    color: ${({ theme, inView }) =>
        inView ? theme.colors.primary.red : theme.colors.text.lightBlue};
    line-height: 1.08;
    font-size: ${dynamicFontSize(2.4, 5.4, 6.4)};
`;

const Highlight = ({ highlight, updateInView, itemsInView }) => {
    const { ref, inView, entry } = useInView({
        threshold: 1,
        rootMargin: '-15% 0px -45% 0px'
    });

    useEffect(() => {
        if (entry) {
            updateInView(entry.target.id, inView);
        }
    }, [inView, entry, updateInView]);

    return (
        <Text
            {...{ ref }}
            id={highlight.split(' ').join('-')}
            inView={
                entry &&
                itemsInView.length &&
                entry.target.id === itemsInView[itemsInView.length - 1]
            }
        >
            {formatText(highlight)}
        </Text>
    );
};

Highlight.propTypes = {
    highlight: PropTypes.string.isRequired,
    updateInView: PropTypes.func.isRequired,
    itemsInView: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default Highlight;
